import numeral from 'numeral';

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}

export function cpfMask(num) {
  if (!num) return '';

  const str = String(num).replace(/\D+/g, '');

  if (str.length === 11) {
    return str
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{2})$/, '$1-$2');
  }

  if (str.length === 14) {
    return str
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{2})$/, '$1-$2');
  }

  return str;
}

export function cnpjMask(num) {
  if (!num) return '00.000.000/0000-00';

  const str = String(num).replace(/\D+/g, '').substr(0, 14);

  if (str.length !== 14) return '00.000.000/0000-00';

  return str
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{2})$/, '$1-$2');
}

export function telMask(phone, ddi) {
  if (!phone) return '';

  const cleanPhone = phone.toString().replace(/\D/g, '');
  const cleanDDI = ddi ? ddi.toString().replace(/\D/g, '') : '';

  if (!cleanDDI || !cleanPhone) return phone;

  const formats = {
    // Brasil: +55 (99) 9 1234-5678
    55: (num) => {
      if (num.length === 11) {
        return `+55 (${num.slice(0, 2)}) ${num.slice(2, 3)} ${num.slice(3, 7)}-${num.slice(7)}`;
      }
      if (num.length === 10) {
        return `+55 (${num.slice(0, 2)}) ${num.slice(2, 6)}-${num.slice(6)}`;
      }
      return `+55 ${num}`;
    },

    // Estados Unidos/Canadá: +1 (555) 123-4567
    1: (num) => {
      if (num.length === 10) {
        return `+1 (${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
      }
      return `+1 ${num}`;
    },

    // Reino Unido: +44 20 1234 5678
    44: (num) => {
      if (num.length === 10) {
        return `+44 ${num.slice(0, 2)} ${num.slice(2, 6)} ${num.slice(6)}`;
      }
      return `+44 ${num}`;
    },

    // Portugal: +351 912 345 678
    351: (num) => {
      if (num.length === 9) {
        return `+351 ${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6)}`;
      }
      return `+351 ${num}`;
    },

    // Argentina: +54 11 1234-5678
    54: (num) => {
      if (num.length === 10) {
        return `+54 ${num.slice(0, 2)} ${num.slice(2, 6)}-${num.slice(6)}`;
      }
      return `+54 ${num}`;
    },

    // Alemanha: +49 30 12345678
    49: (num) => {
      if (num.length >= 10) {
        return `+49 ${num.slice(0, 2)} ${num.slice(2)}`;
      }
      return `+49 ${num}`;
    },

    // França: +33 1 23 45 67 89
    33: (num) => {
      if (num.length === 9) {
        return `+33 ${num.slice(0, 1)} ${num.slice(1, 3)} ${num.slice(3, 5)} ${num.slice(5, 7)} ${num.slice(7)}`;
      }
      return `+33 ${num}`;
    },

    // Itália: +39 06 1234 5678
    39: (num) => {
      if (num.length >= 9) {
        return `+39 ${num.slice(0, 2)} ${num.slice(2, 6)} ${num.slice(6)}`;
      }
      return `+39 ${num}`;
    },

    // Espanha: +34 912 345 678
    34: (num) => {
      if (num.length === 9) {
        return `+34 ${num.slice(0, 3)} ${num.slice(3, 6)} ${num.slice(6)}`;
      }
      return `+34 ${num}`;
    },

    // Japão: +81 3-1234-5678
    81: (num) => {
      if (num.length === 10) {
        return `+81 ${num.slice(0, 1)}-${num.slice(1, 5)}-${num.slice(5)}`;
      }
      return `+81 ${num}`;
    },

    // China: +86 10 1234 5678
    86: (num) => {
      if (num.length === 11) {
        return `+86 ${num.slice(0, 3)} ${num.slice(3, 7)} ${num.slice(7)}`;
      }
      return `+86 ${num}`;
    },

    // Índia: +91 98765 43210
    91: (num) => {
      if (num.length === 10) {
        return `+91 ${num.slice(0, 5)} ${num.slice(5)}`;
      }
      return `+91 ${num}`;
    },

    // Austrália: +61 4 1234 5678
    61: (num) => {
      if (num.length === 9) {
        return `+61 ${num.slice(0, 1)} ${num.slice(1, 5)} ${num.slice(5)}`;
      }
      return `+61 ${num}`;
    },

    // México: +52 55 1234 5678
    52: (num) => {
      if (num.length === 10) {
        return `+52 ${num.slice(0, 2)} ${num.slice(2, 6)} ${num.slice(6)}`;
      }
      return `+52 ${num}`;
    },

    // África do Sul: +27 82 123 4567
    27: (num) => {
      if (num.length === 9) {
        return `+27 ${num.slice(0, 2)} ${num.slice(2, 5)} ${num.slice(5)}`;
      }
      return `+27 ${num}`;
    },
  };

  // Se existe formato específico para o DDI, usa ele
  if (formats[cleanDDI]) {
    return formats[cleanDDI](cleanPhone);
  }

  // Formato padrão genérico: +XXX XXXXXXXXXX (agrupa em blocos de 4)
  const formatted = cleanPhone.match(/.{1,4}/g)?.join(' ') || cleanPhone;
  return `+${cleanDDI} ${formatted}`;
}
